import React, { Component } from "react"
import { Link, Redirect } from "react-router-dom"
import { Animated } from "react-animated-css"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import auth from '../../utils/auth'
import cfg from '../../utils/config'
import axios from 'axios'
import './style.css'

const CODIGO_TAMANHO = 7

class Login extends Component {

    state = {
        step: 1,
        email: "",
        codigoDigits: Array(CODIGO_TAMANHO).fill(""),
        nova_senha: "",
        confirme_senha: "",
        msgbox: '',
        redirectToReferrer: false,
        showmessage: false,
        logomarca: null,
        loadcomplete: false,
        loading: false,
        reenviando: false,
        cooldownReenvio: 0,
        config: { "logomarca": "logomarcas/kronlogo.png", "descricao_horario_atendimento": "Seg. a Sex. das 8:00 às 18:00 ", "email_contato": "contato@ghidro.com.br ", "endereco": "Rua Carlos Ferrari, 18, Sala 610 – Centro – Garça/SP", "facebook": "https://www.facebook.com/ghidromonitoramento/", "link_criar_conta": "https://www.ghidro.com.br", "linkedin": "https://www.linkedin.com/company/g-hidro-monitoramento/", "telefone": "(14) 98161-0616", "youtube": "https://www.youtube.com/channel/UCj1BOaOQTuPMrTgPewSwgvw" },
        cores: { "degrade_top_primeira_cor": "#F44E3B", "degrade_top_segunda_cor": "#2f577b", "back_logomarca": "#37424A", "back_menu_lateral": "#37424A", "fonte_menu_lateral": "#c7c7c7", "fonte_grupo_menu_lateral": "#c7c7c7" },
        modalToggle: false
    }

    codigoRefs = Array.from({ length: CODIGO_TAMANHO }, () => React.createRef())

    cooldownInterval = null

    componentWillUnmount = () => {
        if (this.cooldownInterval) clearInterval(this.cooldownInterval)
    }

    componentWillMount = () => {
        let requestArray = []
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } };
        let domain = window.location.host

        requestArray.push(axios.get(cfg.base_api_url + cfg.api_v2 +  `/configuracao-login/?domain=${domain}`, config_me))

        axios.all(requestArray)
        .then(axios.spread((config) => {

            let cores = ''
            let logomarca = ''
            let config_nova = ''

            cores = config.data.cores
            logomarca = config.data.config.logomarca
            config_nova = config.data.config
            document.title = config.data.config.titulo_sistema ?? "Afira"

            this.setState({ cores: cores, opacity: 1, logomarca: logomarca, loadcomplete: true, 'config': config_nova })

        }));
    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            if (this.state.step === 1) {
                this.handleEmailSubmit(e)
            } else if (this.state.step === 3) {
                this.handleNovaSenhaSubmit(e)
            }
        }
    }

    handleEmailSubmit = (e) => {
        e.preventDefault();

        if (this.state.loading) return

        const requestURL = cfg.base_api_url + cfg.api_v2 + '/confirmacao-email/'
        const config = { headers: { 'Content-Type': 'application/json' } }

        let body = { email: this.state.email }

        this.setState({ loading: true })

        axios.post(requestURL, body, config)
        .then(() => {
            this.setState({ step: 2 })
        })

        .catch((error) => {
            this.setState({
                showmessage: true,
                msgbox: this.getErrorMessage(error)
            })
            setTimeout(() => {
                this.setState({
                    showmessage: false,
                    msgbox: ''
                })
                }, 5000)
            })

        .finally(() => {
            this.setState({ loading: false })
        })
    }

    handleCodigoDigitChange = (index, e) => {
        if (this.state.loading) return

        let valor = e.target.value.slice(-1)
        let codigoDigits = [...this.state.codigoDigits]
        codigoDigits[index] = valor

        this.setState({ codigoDigits })

        if (valor && index < CODIGO_TAMANHO - 1) {
            const proximo = this.codigoRefs[index + 1].current
            if (proximo) proximo.focus()
        }
    }

    handleCodigoDigitKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !this.state.codigoDigits[index] && index > 0) {
            const anterior = this.codigoRefs[index - 1].current
            if (anterior) anterior.focus()
        } else if (e.key === 'Enter') {
            this.handleCodigoSubmit(e)
        }
    }

    handleCodigoPaste = (index, e) => {
        e.preventDefault()

        let pasted = (e.clipboardData || window.clipboardData).getData('text').trim()
        if (!pasted) return

        let chars = pasted.split('')
        let codigoDigits = [...this.state.codigoDigits]

        for (let i = 0; i < chars.length && (index + i) < CODIGO_TAMANHO; i++) {
            codigoDigits[index + i] = chars[i]
        }

        this.setState({ codigoDigits })

        let ultimoIndex = Math.min(index + chars.length, CODIGO_TAMANHO) - 1
        const ultimoRef = ultimoIndex >= 0 ? this.codigoRefs[ultimoIndex].current : null
        if (ultimoRef) ultimoRef.focus()
    }

    handleCodigoSubmit = (e) => {
        e.preventDefault();

        if (this.state.loading) return

        const requestURL = cfg.base_api_url + cfg.api_v2 + '/confirmacao-codigo/'
        const config = { headers: { 'Content-Type': 'application/json' } }

        let body = {
            email: this.state.email,
            codigo: this.state.codigoDigits.join('')
        }

        this.setState({ loading: true })

        axios.post(requestURL, body, config)
        .then(() => {
            this.setState({ step: 3 })
        })

        .catch((error) => {
            this.setState({
                showmessage: true,
                msgbox: this.getErrorMessage(error)
            })

            setTimeout(() => {
                this.setState({
                    showmessage: false,
                    msgbox: ''
                })
                }, 5000)
            })

        .finally(() => {
            this.setState({ loading: false })
        })
    }

    iniciarCooldownReenvio = () => {
        if (this.cooldownInterval) clearInterval(this.cooldownInterval)

        this.setState({ cooldownReenvio: 60 })

        this.cooldownInterval = setInterval(() => {
            this.setState((prevState) => {
                if (prevState.cooldownReenvio <= 1) {
                    clearInterval(this.cooldownInterval)
                    return { cooldownReenvio: 0 }
                }
                return { cooldownReenvio: prevState.cooldownReenvio - 1 }
            })
        }, 1000)
    }

    reenviarCodigo = (e) => {
        e.preventDefault()

        if (this.state.loading || this.state.reenviando || this.state.cooldownReenvio > 0) return

        const requestURL = cfg.base_api_url + cfg.api_v2 + '/confirmacao-email/'
        const config = { headers: { 'Content-Type': 'application/json' } }

        let body = { email: this.state.email }

        this.setState({ reenviando: true })

        axios.post(requestURL, body, config)
        .then(() => {
            this.iniciarCooldownReenvio()
            this.setState({ showmessage: true, msgbox: 'Código reenviado com sucesso.' })
            setTimeout(() => {
                this.setState({ showmessage: false, msgbox: '' })
            }, 5000)
        })
        .catch((error) => {
            this.setState({
                showmessage: true,
                msgbox: this.getErrorMessage(error)
            })
            setTimeout(() => {
                this.setState({ showmessage: false, msgbox: '' })
            }, 5000)
        })
        .finally(() => {
            this.setState({ reenviando: false })
        })
    }

    handleNovaSenhaSubmit = (e) => {
        e.preventDefault();

        if (this.state.loading) return

        if (this.state.nova_senha !== this.state.confirme_senha) {
            this.setState({ showmessage: true, msgbox: 'As senhas digitadas são diferentes.' })
            setTimeout(() => {
                this.setState({ showmessage: false, msgbox: '' })
            }, 5000)
            return
        }

        const requestURL = cfg.base_api_url + cfg.api_v2 + '/nova-senha/'
        const config = { headers: { 'Content-Type': 'application/json' } }

        let body = {
            email: this.state.email,
            nova_senha: this.state.nova_senha,
            confirme_senha: this.state.confirme_senha
        }

        this.setState({ loading: true })

        axios.post(requestURL, body, config)
        .then(() => {
            this.setState({ modalToggle: true })
        })
        .catch((error) => {
            this.setState({
                showmessage: true,
                msgbox: this.getErrorMessage(error)
            })

            setTimeout(() => {
                this.setState({
                    showmessage: false,
                    msgbox: ''
                })
                }, 5000)
            })
        .finally(() => {
            this.setState({ loading: false })
        })
    }

    renderBtnStyle = () => {
        return {
            'background': this.state.cores.login_informacao_background,
            color: this.state.cores.login_formulario_fonte_cor,
            opacity: this.state.loading ? 0.7 : 1,
            cursor: this.state.loading ? 'not-allowed' : 'pointer'
        }
    }

    renderStep = () => {
        const { step } = this.state

        if (step === 1) {
            return (
                <form>
                    <input placeholder="Digite seu e-mail ..." type="text" id="email" value={this.state.email} onChange={e => this.setState({ email: e.target.value })} onKeyPress={this.handleKeyPress} className="campo-form" />
                    <div>
                        <div style={this.renderBtnStyle()} className="btn-login" onClick={!this.state.loading ? this.handleEmailSubmit : undefined}>{this.state.loading ? "Validando e-mail..." : "Confirmar"}</div>
                    </div>
                    <div className="esqueci-minha-senha">
                        <Link to="/login">
                            Voltar ao Sistema
                        </Link>
                    </div>
                </form>
            )
        }

        if (step === 2) {
            return (
                <form>
                    <div className="texto-instrucao">Enviamos um código de verificação para <strong>{this.state.email}</strong>. Digite-o abaixo para continuar.</div>
                    <div className="codigo-input-group">
                        {this.state.codigoDigits.map((digito, index) => (
                            <input
                                key={index}
                                ref={this.codigoRefs[index]}
                                type="text"
                                inputMode="text"
                                maxLength={1}
                                autoComplete="off"
                                autoFocus={index === 0}
                                value={digito}
                                onChange={(e) => this.handleCodigoDigitChange(index, e)}
                                onKeyDown={(e) => this.handleCodigoDigitKeyDown(index, e)}
                                onPaste={(e) => this.handleCodigoPaste(index, e)}
                            />
                        ))}
                    </div>
                    <div>
                        <div style={this.renderBtnStyle()} className="btn-login" onClick={!this.state.loading ? this.handleCodigoSubmit : undefined}>{this.state.loading ? "Validando..." : "Confirmar"}</div>
                    </div>
                    <div className="reenviar-codigo">
                        {this.state.cooldownReenvio > 0
                            ? <span className="reenviar-codigo-desabilitado">Reenviar código em {this.state.cooldownReenvio}s</span>
                            : <a href="#" onClick={this.reenviarCodigo}>{this.state.reenviando ? "Reenviando..." : "Reenviar Código"}</a>
                        }
                    </div>
                    <div className="esqueci-minha-senha">
                        <Link to="/login">
                            Voltar ao Sistema
                        </Link>
                    </div>
                </form>
            )
        }

        return (
            <form>
                <input placeholder="Nova senha ..." type="password" id="nova_senha" value={this.state.nova_senha} onChange={e => this.setState({ nova_senha: e.target.value })} onKeyPress={this.handleKeyPress} className="campo-form" />
                <input placeholder="Confirme a nova senha ..." type="password" id="confirme_senha" value={this.state.confirme_senha} onChange={e => this.setState({ confirme_senha: e.target.value })} onKeyPress={this.handleKeyPress} className="campo-form" />
                <div>
                    <div style={this.renderBtnStyle()} className="btn-login" onClick={!this.state.loading ? this.handleNovaSenhaSubmit : undefined}>{this.state.loading ? "Redefinindo..." : "Redefinir Senha"}</div>
                </div>
            </form>
        )
    }

    getErrorMessage = (error) => {
        return (
            error?.response?.data?.error?.[0] ||
            error?.response?.data?.message ||
            error?.message ||
            "Ocorreu um erro. Tente novamente."
        )
    }

    render() {
        const { from } = this.props.location.state || { from: { pathname: "/login" } }
        const { redirectToReferrer, step } = this.state

        if (redirectToReferrer) {
            return <Redirect to="/login" />
        }

        if (auth.getToken() !== null) {
            return <Redirect to={from} />
        }

        const titulos = {
            1: "Recuperar Senha",
            2: "Confirmar Código",
            3: "Nova Senha"
        }

        return (
            <>
                <Modal isOpen={this.state.modalToggle}>
                    <ModalHeader>
                        Aviso
                    </ModalHeader>
                    <ModalBody>
                        Sua senha foi redefinida com sucesso. Ao clicar em Continuar você será redirecionado para a tela de login.
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={() => this.setState({modalToggle: false, redirectToReferrer: true})} color="success">Continuar</Button>
                    </ModalFooter>
                </Modal>
                <div className={(this.state.loadcomplete) ? "body-page" : "hdv-noshow-item"} style={{ 'background': `linear-gradient(to right, ${this.state.cores.login_informacao_background} 50%, transparent 50%` }}>
                    <div className="container-login" style={{ 'backgroundColor': this.state.cores.login_informacao_background }}>
                        <div className="login-logo-sociais">
                            <div className="logomarca">
                                <img style={{filter: this.state.cores.filtro_logo ? 'brightness(0) invert(1)' : '', maxWidth: "200px"}} src={this.state.logomarca}/>
                            </div>
                        </div>
                        <div className="form-login" style={{ 'backgroundColor': this.state.cores.login_formulario_background }}>

                            <div className="imagem-titulo" style={{width: "160px", height: "100px", backgroundImage: this.state.logomarca ? `url(${this.state.logomarca})` : 'none', backgroundRepeat: "no-repeat", backgroundPosition: "center", backgroundSize: "cover", margin: "0 auto"}}></div>

                            <div className="titulo">{titulos[step]}</div>

                            {this.renderStep()}
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default Login;